<template>
  <div v-loading="ladingFlag" class="dms-app common-sub-app">
    <micro-app
      ref="micro"
      class="microAppClassName"
      style="height: 100%"
      :name="name"
      :url="pageUrl"
      keep-alive
      disable-memory-router
      disable-patch-request
      keep-router-state
      :data="dataForChild"
      baseroute="/st-dms"
      @datachange="handleDataChange"
      @created="handleCreate"
      @beforemount="handleBeforeMount"
      @mounted="handleMount"
      @unmount="handleUnmount"
      @error="handleError"
      @beforeshow="beforeshow"
      @aftershow="aftershow"
    />
  </div>
</template>

<script>
import urlConfig from './urlConfig'
import { SappModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import microApp from '@micro-zoe/micro-app'
import Cookies from 'js-cookie'
export default {
  name: 'DmsApp',
  data() {
    let envStr = process.env.VUE_APP_ENV || ''
    const itmsSite = Cookies.get('itms-site') || 'sg'
    if (this.getEnvironment() === 1) {
      itmsSite === 'eu' && (envStr = 'siteEu')
    } else if (this.getEnvironment() === 2) {
      itmsSite === 'eu' && (envStr = 'siteEuGray')
    }
    return {
      name: 'dms',
      retryTimes: 0,
      loading: null,
      dataForChild: {
        type: '发送给子应用的数据',
        editableTab: SappModule.editableTabs,
        fullname: UserModule.fullname,
        username: UserModule.username,
        siteCode: UserModule.siteCode,
        siteName: UserModule.siteName,
        butsPermission: SappModule.butsPermission,
        siteType: UserModule.siteType,
        subType: UserModule.subType,
        email: UserModule.email,
        processSiteType: UserModule.processSiteType,
        processRole: UserModule.processRole,
        pushState: (to) => {
          window.microApp.setData('dms', { path: to.fullPath })
        }
      },
      pageUrl: urlConfig.dms[envStr],
      ladingFlag: false
    }
  },
  mounted() {
    console.log('进入dms子应用页面')
  },
  methods: {
    getEnvironment() {
      const hostname = window.location.hostname

      switch (hostname) {
        case 'itms.jd.com':
          return 1
        case 'itms-gray.jd.com':
          return 2
        default:
          return 3
      }
    },
    handleDataChange({ detail = {} }) {
      // 从detail对象中获取data属性，如果不存在则默认为空对象
      const data = detail.data || {}
      console.log('返回了跳转routerChange22', data)
      // 判断data的type属性是否为'routerChange'
      if (data.type === 'routerChange') {
        console.log('返回了跳转routerChange', data)
        // 打印data.info到控制台
        // 判断data.info.path是否存在且不等于'/'，并且不包含'st-dms'字符串
        if (data.info.path && data.info.path !== '/' && data.info.path.indexOf('st-dms') < 0) {
          // 将data.info.path前面加上'/st-dms'
          data.info.path = `/st-dms${data.info.path}`
        }

        // 删除data.info对象中的name属性
        delete data.info.name

        // 使用Vue的$nextTick方法，在下次DOM更新循环结束之后执行回调函数
        this.$nextTick(() => {
          // 将data.info对象转换为JSON字符串并打印到控制台
          try {
            const routerData = JSON.parse(JSON.stringify(data.info))
            this.$router.push({
              ...routerData,
              query: {
                ...routerData.query,
                ...routerData.params
              }
            })
          } catch (error) {

          }
        })
      } else if (data.type === 'closeTab') {
        // 如果data.type为'closeAndOpenNewTab'，暂时不做任何处理
        SappModule.removeTab(`/st-dms${data.info.path}`)
      } else if (data.type === 'closeAndOpenNewTab') {
        // 如果data.type为'closeAndOpenNewTab'，暂时不做任何处理
        SappModule.removeTab(`/st-dms${data.info.path}`)
      } else if (data.type === 'setPermission') {
        // 如果data.type为'setPermission'，暂时不做任何处理
      }
    },
    handleCreate() {
      this.ladingFlag = true
      console.log('初始化dms子应用成功')
    },

    handleBeforeMount() {
      this.ladingFlag = true
      console.log('初始化dms子应用handleBeforeMount')
    },

    handleMount() {
      console.log('初始化dms子应用handleMount')
      try {
        const contentWrapper = document.querySelector('.content-wrapper')
        if (contentWrapper) {
          contentWrapper.setAttribute('style', 'background-color:#F5F5F6;')
        }
      } catch (e) {
        console.log(e)
      }
      setTimeout(() => {
        this.ladingFlag = false
      })
    },

    handleUnmount() {
      try {
        const contentWrapper = document.querySelector('.content-wrapper')
        const imgView = document.querySelector('.express-center-box')
        if (contentWrapper) {
        }
        this.$nextTick(() => {
          if (imgView) {
            if (this.$route.path === '/' || this.$route.path === '/helpCenter' || this.$route.path === '/home/welcome') {
              imgView.setAttribute('style', 'margin-left:-100px;')
            } else {
              imgView.setAttribute('style', 'margin-left:0px;')
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    handleError(e) {
      console.log('idms子应用加载失败，重新加载', e)
      if (this.retryTimes < 2) {
        this.retryTimes++
        setTimeout(() => {
          microApp.reload(this.name)
        }, 1000)
      }
    },
    created() {
      this.ladingFlag = true
    },
    beforeshow() {
      this.ladingFlag = false
      console.log('即将重新渲染，初始化时不执行')
    },
    aftershow() {
      console.log('已经重新渲染，初始化时不执行')
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";
.dms-app{
  margin-top: 0px;
  padding: 0px 0 0px 0;
   height: calc(100vh - 144px);
   .circular{
    background-image: url('~@/assets/img/loading.gif');
    width: 300px;
    height: 300px;
   }
   .el-loading-spinner{
    margin-top: -150px;
    top: 40vh;
   }
   micro-app[name="dms"] {
    height: 100%;
    width: 100%;
   }
}
</style>
